import { Package, Boxes, HardHat, KeyRound, Wrench, ClipboardCheck } from "lucide-react";

export const RESOURCE_TYPES = ["Producto", "Material", "Mano de obra", "Alquiler", "Servicio", "Tarea"];

export const TYPE_META = {
  "Producto": { icon: Package, className: "bg-sky-100 text-sky-800 border-sky-200" },
  "Material": { icon: Boxes, className: "bg-amber-100 text-amber-800 border-amber-200" },
  "Mano de obra": { icon: HardHat, className: "bg-orange-100 text-orange-900 border-orange-200" },
  "Alquiler": { icon: KeyRound, className: "bg-violet-100 text-violet-800 border-violet-200" },
  "Servicio": { icon: Wrench, className: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  "Tarea": { icon: ClipboardCheck, className: "bg-rose-100 text-rose-800 border-rose-200" },
};

const EUR = new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", minimumFractionDigits: 2 });

export function formatEuro(n) {
  return EUR.format(Number(n || 0));
}
